import { render, staticRenderFns } from "./CreateFormBasicInfo.vue?vue&type=template&id=2eb260bf&scoped=true&"
import script from "./CreateFormBasicInfo.vue?vue&type=script&lang=js&"
export * from "./CreateFormBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./CreateFormBasicInfo.vue?vue&type=style&index=0&id=2eb260bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb260bf",
  null
  
)

export default component.exports